module.exports = __webpack_public_path__ + "img/device_logo.726c16cc.png";